import { initNavbarDesktop } from '@layout/nav-v2/desktop/initNavbarDesktop';
import { initNavbarMobile } from '@layout/nav-v2/mobile/initNavbarMobile';

export const nav = (): void => {
  initNavbarDesktop();
  initNavbarMobile();
};
